import { Button } from '@realtyka/real-ui';
import React from 'react';
import ShieldKeyhole from '../../../assets/img/shield-keyhole.svg';
import useDeviceType from '../../../hooks/useDeviceType';

export interface MfaCardProps {
  withShieldIcon?: boolean;
  title: string;
  children: React.ReactNode;
  buttonText?: string;
  onButtonClick?: () => void;
}

const MfaCard: React.FC<MfaCardProps> = ({
  title,
  children,
  withShieldIcon = false,
  buttonText,
  onButtonClick,
}) => {
  const { isMobile } = useDeviceType();

  return (
    <div className='flex flex-col justify-start md:justify-center items-center w-full h-full my-4'>
      <div className='flex flex-col items-center w-[340px] md:w-[524px] p-4 md:p-10 border border-reskin-grey-300 rounded-xl bg-white shadow-sm'>
        {withShieldIcon ? (
          <div className='flex justify-center items-center gap-y-2 self-stretch mb-6'>
            <img src={ShieldKeyhole} alt='shield-keyhole' className='w-8 h-8' />
          </div>
        ) : (
          <div className='text-center  text-reskin-regent-600 font-inter-regular text-sm leading-5 mb-2'>
            Two-Factor Authentication
          </div>
        )}
        <div className='text-reskin-primary-dark text-center font-poppins-semibold text-[20px] md:text-[32px] tracking-[-0.5px] leading-[22px] md:leading-9'>
          {title}
        </div>
        {children}
        {buttonText && onButtonClick && (
          <div className='mt-2 w-full'>
            <Button
              variant='outline'
              size={isMobile ? 'sm' : 'md'}
              type='button'
              fullWidth
              color='secondary'
              onClick={onButtonClick}
            >
              <div className='font-medium'>{buttonText}</div>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MfaCard;
